import Alpine from 'alpinejs'

Alpine.data(
  'countUp',
  (
    to,
    {
      from = 0,
      duration = 1_250,
      easing = 'easeOutQuad',
      trigger = 'intersect',
      delimiter = null,
    } = {},
  ) => {
    const formatter = new Intl.NumberFormat('en-US')

    return {
      // Current value
      countUp: 0,

      get countUpFormatted() {
        if (!delimiter) return this.countUp.toString()
        return formatter.format(this.countUp).replaceAll(',', delimiter)
      },

      easeOutCubic: t => --t * t * t + 1,
      easeOutQuad: t => t * (2 - t),
      easeOutQuart: t => 1 - --t * t * t * t,
      easeOutQuint: t => 1 + --t * t * t * t * t,
      easeOutExpo: t => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
      start() {
        const start = performance.now()
        const step = now => {
          const rawProgress = (now - start) / duration
          const eased = (this[easing] ?? this.easeOutCubic)(Math.min(rawProgress, 1))
          this.countUp = from + Math.floor(eased * (to - from))
          if (rawProgress < 1) requestAnimationFrame(step)
          else this.countUp = to
        }
        requestAnimationFrame(step)
      },

      init() {
        if (trigger === 'load') {
          this.start()
        } else {
          const observer = new IntersectionObserver(
            entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  this.start()
                  observer.disconnect()
                }
              })
            },
            {
              rootMargin: '-60px',
            },
          )

          observer.observe(this.$el)
        }
      },
    }
  },
)
